import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { faMale } from "@fortawesome/free-solid-svg-icons";
import { faChild } from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { FlagService, AgeGroupService, DataService } from '@core/services';
import { HIPContractDto } from 'src/app/modules/_services/api/@generated/models';
import moment from 'moment/moment';
import { GeneralUtils } from '@shared/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-age-juncture',
  templateUrl: './age-juncture.component.html',
  styleUrls: ['./age-juncture.component.scss'],
  standalone: false
})
export class AgeJunctureComponent implements OnInit, OnChanges {
  faMale = faMale;
  faChild = faChild;
  faInfoCircle = faInfoCircle;
  @Input() HIPContractDto: HIPContractDto;
  @Input() lang: string; // to trigger onChanges..
  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  availableChildrenOffer = false;
  availableAdultOffer = false;

  _birthYear = '';
  _birthMonth = '';
  _birthDay = '';

  public insurance = '';
  public fromAge = '';
  public toAge = '';
  public fromAge2 = '';
  public fromTime = '';
  public toAge2 = '';

  public validationStarted = false;
  public birthDateIsValid = false;
  public hasOffer = false;
  public startDate = '';

  constructor(private DropdownFrame: DropdownFrameComponent, public FlagService: FlagService, public AgeGroupService: AgeGroupService,
              public dataService: DataService, public generalUtils: GeneralUtils,
              private translate: TranslateService) {}

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    const customStartDate: string = sessionStorage.getItem('customStartDate');
    if (customStartDate === 'true') {
      this.startDate = moment().add(1, 'day').format('YYYY-MM-DD');
    } else {
      this.startDate = this.HIPContractDto ? this.HIPContractDto.subContractNextStartDate : '';
    }

    if (this.HIPContractDto && this.HIPContractDto.koopFrameContractId === '53870659') {
      this.availableAdultOffer = true;
      this.availableChildrenOffer = false;
    } else if (this.dataService.isKompakt()) {
      this.availableAdultOffer = true;
      this.availableChildrenOffer = true;
    } else {
      if(this.HIPContractDto) {
        for (var i = 0; i < this.HIPContractDto.contractGroups.length; i++) {
          this.HIPContractDto.contractGroups[i].forChildren? this.availableChildrenOffer = true : this.availableAdultOffer = true;
        }
      }
    }

    if (this.HIPContractDto) {
      this.checkAges();
    }
  }

  private checkAges(): void {
    this.insurance = this.translate.instant(
      this.dataService.isKompakt() ? 'junctures.age.insurance.kompakt' : 'junctures.age.insurance.notKompakt');
    if (this.availableChildrenOffer) {
//      this.fromAge2 = this.dataService.isKompakt() ? '12' : '6';
      this.fromAge2 = this.HIPContractDto.hipAgeLimitType.minimumAgeLimit.toString();
      this.fromTime = this.translate.store.currentLang === 'en' ?
        this.HIPContractDto.hipAgeLimitType.minimumAgeLimitTpyeEnglish :
        this.HIPContractDto.hipAgeLimitType.minimumAgeLimitType;
      this.toAge2 = (this.HIPContractDto.ageOfAdultPackage - 1).toString();
    }
    if (this.availableAdultOffer) {
      this.fromAge = this.HIPContractDto.ageOfAdultPackage.toString();
//      this.toAge = this.dataService.isKompakt() ? '65' : '69';
      this.toAge = this.HIPContractDto.hipAgeLimitType.maximumAgeLimit.toString();
    }
  }

  ageJunctureClick() {
    sessionStorage.removeItem("choosenOffer");
    this.DropdownFrame.junctureClick('offerJunctureFlag', 1);
  }

  sendChoosenAgeGroup(ageId: string): void {
    this.FlagService.bannerVisible = false;
    this.AgeGroupService.choosenAgeGroup = [this.AgeGroupService.getAgeChoicesArray().find( ({id}) => id === ageId )];
    // store choosen age group for session progress
    sessionStorage.setItem('ageGroup', JSON.stringify(this.AgeGroupService.choosenAgeGroup));
    sessionStorage.setItem('birthDay', this._birthYear + '-' + this._birthMonth + '-' + this._birthDay);

    this.ageJunctureClick();
    this.newInsurantDataLocation.emit('riskStartDate');
    this.newInsurantDataEvent.emit({riskStartDate: this.HIPContractDto.subContractNextStartDate});
  }

  public birthInputChange(): void {
    if (this._birthYear === '' || this._birthMonth === '' || this._birthDay === '') {
      return;
    }
    this.validationStarted = true;
    this.hasOffer = false;
    const bDay = this._birthYear + '-' + this._birthMonth + '-' + this._birthDay;
    this.birthDateIsValid = moment(bDay, 'YYYY-MM-DD').format('YYYY-MM-DD') === bDay;
    if (this.birthDateIsValid) {
      let ageGroup = '';

      const riskStartDateYear: number = +(moment(this.startDate).format('YYYY'));
      const birthDateYear: number = +(this._birthYear);
      const age: number = riskStartDateYear - birthDateYear;

      const adult: boolean = (this.HIPContractDto.ageOfAdultPackage <= age) && (age <= this.HIPContractDto.hipAgeLimitType.maximumAgeLimit);
      let child: boolean;

      switch (this.HIPContractDto.hipAgeLimitType.minimumAgeLimitType) {
        case 'éves':
          child = this.HIPContractDto.hipAgeLimitType.minimumAgeLimit <= age && age <= (this.HIPContractDto.ageOfAdultPackage - 1);
          break;
        case 'hónapos':
          const riskStartDate = moment(this.startDate);
          const birthDate = moment(bDay);

          child = (riskStartDate >= birthDate.add(this.HIPContractDto.hipAgeLimitType.minimumAgeLimit, 'months'))
            && age <= (this.HIPContractDto.ageOfAdultPackage - 1);
          break;
      }

      if (adult) {
        ageGroup = '01';  // felnőtt
      } else if (child) {
        ageGroup = '02';  // gyermek
      }

      if (ageGroup !== '') {  // adult || child
        this.AgeGroupService.choosenAgeGroup = [this.AgeGroupService.getAgeChoicesArray().find( ({id}) => id === ageGroup )];
        this.hasOffer = true;
      }
    }
  }
}
